import script from "./InstructionStepsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionStepsCard.vue?vue&type=script&setup=true&lang=js"

import "./InstructionStepsCard.vue?vue&type=style&index=0&id=6bf2e787&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bf2e787"]])

export default __exports__